import { Box, CircularProgress, Typography, Pagination } from '@mui/material';
import { useId, type FC } from 'react';
import OrderCard from './OrderCard';
import type { OrderStateEnum } from 'models/enums/orderStateEnum';
import type { Order } from 'models/order/order';

const MobileOrdersList: FC<{
  orders: Order[];
  isLoading: boolean;
  onOrderClick: (orderId: string) => void;
  getActionInfo: (order: Order) => { name: string; color: string } | null;
  ordersType: OrderStateEnum;
  paginationModel: { page: number; pageSize: number };
  totalCount: number;
  onPaginationChange: (page: number) => void;
}> = ({
  orders,
  isLoading,
  onOrderClick,
  getActionInfo,
  ordersType,
  paginationModel,
  totalCount,
  onPaginationChange,
}) => {
  const componentId = useId();

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress aria-label='Загрузка заказов' />
      </Box>
    );
  }

  if (!orders.length) {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant='body1' color='text.secondary'>
          Заказы не найдены
        </Typography>
      </Box>
    );
  }

  const totalPages = Math.ceil(totalCount / paginationModel.pageSize);

  return (
    <Box sx={{ px: 2 }}>
      <Box role='list' aria-label='Список заказов' sx={{ mb: 3 }}>
        {orders.map((order) => (
          <Box key={`${componentId}-order-card-${order.id}`} role='listitem'>
            <OrderCard
              order={order}
              onClick={() => {
                onOrderClick(String(order.id));
              }}
              getActionInfo={getActionInfo}
              ordersType={ordersType}
            />
          </Box>
        ))}
      </Box>

      {totalPages > 1 && (
        <Box sx={{ display: 'flex', justifyContent: 'center', pb: 2 }}>
          <Pagination
            count={totalPages}
            page={paginationModel.page + 1}
            onChange={(_, page) => {
              onPaginationChange(page - 1);
            }}
            color='primary'
            size='medium'
            showFirstButton
            showLastButton
            aria-label='Навигация по страницам заказов'
          />
        </Box>
      )}
    </Box>
  );
};

export default MobileOrdersList;
